module.exports = __webpack_public_path__ + "img/near_cyl125_axis45.ba392033.jpg";